module.exports = __webpack_public_path__ + "static/media/Sub 10.6a9d437c.JPG";